import {
  successAction,
  types,
  errorAction,
  requestAction,
} from "@authzsvc/api-lib";

import * as at from "../actions/types";

const initialState = {
  loading: false,
  data: {},
};

const myResourcesInManagedResourceType = (state = initialState, action) => {
  switch (action.type) {
    case at.CLEAR_RESOURCES:
      return { ...state, data: {} };
    case errorAction(types.GET_MY_RESOURCES_IN_MANAGED_RESOURCE_TYPE):
      return { ...state, loading: false };
    case successAction(types.GET_MY_RESOURCES_IN_MANAGED_RESOURCE_TYPE):
      return { ...state, data: action.payload.data, loading: false };
    case requestAction(types.GET_MY_RESOURCES_IN_MANAGED_RESOURCE_TYPE):
      return { ...state, loading: true };
    default:
      return state;
  }
};

export default myResourcesInManagedResourceType;
